/**
 * Prix TTC (euros) à afficher à partir des champs WowBooking.
 *
 * Règle métier:
 * - Prix normal en source par défaut.
 * - Prix promo uniquement si renseigné (> 0).
 * - Fallback sur HT + TVA lorsque nécessaire.
 */
export function getDisplayTtcEuros(offer) {
  if (!offer || typeof offer !== 'object') return 0;
  const vatPct = parseFloat(offer.vat_rate);
  const vatMul = Number.isFinite(vatPct) && vatPct > 0 ? 1 + vatPct / 100 : 1.21;

  const read = (...values) => {
    for (const value of values) {
      const n = parseFloat(value);
      if (Number.isFinite(n) && n > 0) return n;
    }
    return null;
  };

  const ttcBase = read(offer.price_ttc, offer.price, offer.base_price_ttc);
  const ttcPromo = read(offer.promo_price_ttc, offer.promotional_price_ttc, offer.promo_price);
  if (ttcPromo != null) return Math.round(ttcPromo);
  if (ttcBase != null) return Math.round(ttcBase);

  const htBase = read(offer.price_ht, offer.base_price_ht);
  const htPromo = read(offer.promo_price_ht, offer.promotional_price_ht);
  const ht = htBase ?? htPromo;
  if (ht == null) return 0;
  return Math.round(ht * vatMul);
}
